import { useEffect, useState, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ResumeUpdateContext } from "../../Context/resumeUpdateContext";
import { jsonEditorContext } from "../../Context/jsonEditorContext";
import { ResumePopupContext } from "../../Context/resumePopupContext";
import { isJobPresent } from "../../Store/Actions/ProfileActions";
import {
  resumeEditActions,
  sampleResumeById,
  resumeUpdateToServerFromRedis,
} from "../../Store/Actions/ResumeActions";
import {
  changeLayout,
  calculateHeight,
} from "../../Store/Actions/LayoutActions";
import { EDITOR_DATA_ADD } from "../../Store/Constants/EditorConstants";
import { RESUME_UPDATE_RESET } from "../../Store/Constants/ResumeConstants";
import { undoRedo } from "../../Store/Actions/undoRedoActions";
import { analyzeResume } from "../../Store/Actions/AnalyzeActions";
import { templateGetParticularActions } from "../../Store/Actions/TemplateActions";
import {
  experience,
  achievements,
  skills,
  education,
  interests,
  languages,
  customDate,
  customText,
  paidSections,
  projects,
  volunteering,
  onlinePresence,
  certifications,
  references,
  publications,
  books,
  additionalExperience,
  additionalSkills,
  courses,
  industryExpertise,
  techStack,
  strengths,
} from "../../masterData";
import axios from "axios";

function twoDarrMaker(row, col) {
  const twoDarr = [];
  let column = 0;
  for (let i = 0; i < row; i++) {
    let subarray = [];

    for (let j = 0; j < col; j++) {
      subarray.push(column);
      column++;
    }

    twoDarr.push(subarray);
  }

  return twoDarr;
}
const outerFullHeight = (el) => {
  // Get the DOM Node if you pass in a string
  el = typeof el === "string" ? document.querySelector(el) : el;
  var styles = window.getComputedStyle(el);
  //   if (typeof el != "Element") {
  //     return;
  //   }

  //   var styles = window.getComputedStyle(el, null);
  var margin =
    parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);
  return Math.ceil(el.offsetHeight + margin);
};

const ResumeUseForm = (isJon, json, isSample, showSample, isVisualEditor) => {
  const dispatch = useDispatch();
  const [rand, setRand] = useState(0);
  const [randFocus, setRandFocus] = useState(0);
  const [randLayout, setRandLayout] = useState(1);

  const { sampleModal } = useContext(ResumePopupContext);
  const [visualEditorFocus, setVisualEditorFocus] = useState(false);
  const [isDataUpdated, SetIsDataUpdated] = useState(false);
  const path = window.location.pathname;

  const editorData = useSelector((state) =>
    sampleModal ? state.sampleData : state.editorData
  );
  const { resume } = useSelector((state) => state.resumeGetById);
  const resumeData = useSelector((state) => state.editorData);

  const layoutData = useSelector((state) => state.layout);
  const resumeEditUpdate = useSelector((state) => state.resumeUpdate);
  const isCalculateHeight = useSelector((state) => state.calculateHeight);
  const templateList = useSelector((state) => state.templateList.list);
  const historyUndoRedo = useSelector((state) => state.undoRedo);
  const { userInfo } = useSelector((state) => state.userData);

  const [resumeFields, setResumeFields] = useState({});
  const baseUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (isCalculateHeight === true) {
      setTimeout(() => {
        layoutHandler();
        dispatch(calculateHeight(false));
      }, 500);
    }
  }, [isCalculateHeight]);

  const resumeUpdateToServer = () => {
    if (resume) {
      dispatch(resumeUpdateToServerFromRedis(resume.id));
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      // Your function call here
      if (path && path.includes("resumes")) {
        resumeUpdateToServer();
      }
      console.log("Function called every 1 miniute");
    }, 60000); // 60000 milliseconds = 1 minute

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [resume]);

  const resumePageUpdate = (content, canUpdate, undo) => {
    SetIsDataUpdated(false);
    if (resume) {
      if (rand != 0) {
        var body = { ...resume, content: JSON.stringify(content) };
        dispatch({
          type: EDITOR_DATA_ADD,
          payload: content,
        });
        dispatch(resumeEditActions(resume.id, body, undo));
        setRand(0);
      } else if (canUpdate == true) {
        var body = { ...resume, content: JSON.stringify(content) };
        dispatch({
          type: EDITOR_DATA_ADD,
          payload: content,
        });
        dispatch(resumeEditActions(resume.id, body, undo));
        setRand(0);
      }
    }
  };

  const updateHistoryData = (historyData) => {
    let consData = JSON.parse(historyData.content);
    dispatch(changeLayout(consData.layout));
    setResumeFields(consData);
    dispatch({
      type: EDITOR_DATA_ADD,
      payload: consData,
    });
    var body = { ...historyData };
    dispatch(resumeEditActions(historyData.id, body));
  };

  const resumeNavigateHistory = (type) => {
    let undoHistory = historyUndoRedo?.history;

    if (type === "undo") {
      if (undoHistory.currentIndex >= 0) {
        let timeLineLength = undoHistory.timeline.length;
        if (undoHistory.currentIndex - 1 <= timeLineLength) {
          let undoContent =
            undoHistory.timeline[undoHistory.currentIndex - 1].resumeData;
          let consData = JSON.parse(undoContent.content);
          dispatch(changeLayout(consData.layout));
          setResumeFields(consData);
          dispatch({
            type: EDITOR_DATA_ADD,
            payload: consData,
          });
          undoHistory.currentIndex = undoHistory.currentIndex - 1;
          dispatch(undoRedo({ history: undoHistory }));
          var body = { ...undoContent };
          dispatch(resumeEditActions(undoContent.id, body, "undo"));
        }
      }
    } else if (type === "redo") {
      let timeLineLength = undoHistory.timeline.length;
      if (undoHistory.currentIndex + 1 <= timeLineLength) {
        let undoContent =
          undoHistory.timeline[undoHistory.currentIndex + 1].resumeData;
        let consData = JSON.parse(undoContent.content);
        dispatch(changeLayout(consData.layout));
        setResumeFields(consData);
        dispatch({
          type: EDITOR_DATA_ADD,
          payload: consData,
        });
        undoHistory.currentIndex = undoHistory.currentIndex + 1;
        dispatch(undoRedo({ history: undoHistory }));
        var body = { ...undoContent };
        dispatch(resumeEditActions(undoContent.id, body, "undo"));
      }
    }
  };

  // const onVisibilityChange = () => {
  //   if (document.visibilityState === 'visible' && !visibilityChangeTab) {
  //     setVisibilityChangeTab(current => !current);
  //     layoutHandler();
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("visibilitychange", onVisibilityChange);
  //   return () => document.removeEventListener("visibilitychange", onVisibilityChange);
  // }, []);

  // document.addEventListener("visibilitychange", function() {
  //   if(!visibilityTab){
  //     setVisibilityTab(current => !current);
  //     layoutHandler();
  //   }
  // });
  // For Ai error correction
  const [errorCorrection, setErrorCorrection] = useState({});
  const API_KEY = process.env.REACT_APP_OPEN_API_KEY;

  const { improveTexts, setImproveTexts } = useContext(jsonEditorContext);

  const chatData = async (editorData) => {
    const experienceStrings = editorData?.experience?.data.map(
      (exp) => exp.description
    );
    const experiencesString = experienceStrings.join("\n\n");

    const skillsStrings = editorData.skills.data.map((skills) => skills.name);
    const skillsString = skillsStrings.join("\n\n");

    try {
      const response = await fetch(
        "https://api.openai.com/v1/chat/completions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${API_KEY}`,
          },
          body: JSON.stringify({
            model: "gpt-3.5-turbo",
            messages: [
              { role: "system", content: "You are a like a grammarly." },
              {
                role: "user",
                content: `You are my resume enhancer. I have summary,experience and skills. You have to check the sections and give the grammatical and other errors. Please give each section errors separately in a json format.\n\n Summary: ${editorData?.summary?.data?.[0]?.description} /n/n Experience: ${experiencesString} /n/n Skills:${skillsString}`,
              },
            ],
            temperature: 0.7,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(
          "Oops! Something went wrong while processing your request."
        );
      }

      const responseData = await response.json();
      return responseData;
      // Assuming you have some state management for messages and typing state
    } catch (error) {
      console.error("Error while fetching chat data:", error);
    }
  };

  const handleCheckSpellsAndGrammar = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/checkResumeSpellAndGrammar`,
        {
          ...resume,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            // Add any other headers you might need
          },
        }
      );
      console.log("Response:", response.data);
      alert("Payment History data updated");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (
      resumeEditUpdate &&
      resumeEditUpdate.data &&
      resumeEditUpdate.data.success
    ) {
      // dispatch(analyzeResume(editorData));
      // handleCheckSpellsAndGrammar();
      // chatData(editorData)
      //   .then((result) => {
      //     // alert(result?.choices?.[0]?.message?.content);
      //     setImproveTexts(JSON.parse(result?.choices?.[0]?.message?.content));
      //   })
      //   .catch((error) => {
      //     console.error("Error while fetching data:", error);
      //   });
    }
  }, [resumeEditUpdate]);
  const [heightTrigger, setHeightTrigger] = useState(0);
  useEffect(() => {
    if (
      resumeEditUpdate &&
      resumeEditUpdate.data &&
      resumeEditUpdate.data.success
    ) {
      //If Preview fails in desktop, remove this lines.
      dispatch({ type: RESUME_UPDATE_RESET });
      setTimeout(() => {
        if (!isSample) {
          layoutHandler();
        }
        if (randFocus != 0) {
          setTimeout(() => {
            setRandFocus(0);
            const element =
              document.getElementsByClassName("sectionFocusStyle");
            if (element && element.length > 0) {
              element[0].scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
              });
            }
            if (!isSample) {
              setHeightTrigger(1);
            }
          }, 10);
        }
      }, 10);
    }
  }, [resumeEditUpdate]);

  useEffect(() => {
    if (heightTrigger == 1) {
      setHeightTrigger(0);
      layoutHandler();
    }
  }, [heightTrigger]);

  useEffect(() => {
    if (isJon) {
      setResumeFields(json && json);
    } else {
      if (typeof editorData != "undefined" && !showSample) {
        const clonedEditorData = JSON.parse(JSON.stringify(editorData));
        console.log(clonedEditorData, "clonedEditorData");
        setResumeFields((prevFields) => ({
          ...prevFields,
          ...clonedEditorData,
          lockedFeatures: [...(clonedEditorData.lockedFeatures || [])],
        }));
      }
    }
  }, [editorData, isJon, json]);

  const [saveIndex, setSaveIndex] = useState(-1);
  const { loading } = useSelector((state) => state.editorLoading);

  const [sectionFocusOutsideClick, setSectionFocusOutsideClick] =
    useState(false);
  const [sectionFocus, setSectionFocus] = useState(false);
  const [innerSectionFocus, setInnerSectionFocus] = useState(false);
  const sectionRef = useRef();
  const childRef = useRef();

  const {
    setResumeUpdated,
    resumeUpdated,
    // setVisualEditorFocus,
    setSectionFocusData,
  } = useContext(ResumeUpdateContext);

  //Context
  const {
    showPopup,
    setShowPopup,
    setShowDeletePopup,
    sectionId,
    setSectionId,
    arrayIndex,
    setArrayIndex,
    setCustomIndex,
  } = useContext(ResumePopupContext);

  let height =
    sectionRef && sectionRef.current && sectionRef.current.clientHeight;

  useEffect(() => {
    if (!loading && saveIndex != -1) {
      setSaveIndex(-1);
    }
  }, [loading]);

  const handleCustomEditorChange = (value, index) => {
    let data = JSON.parse(JSON.stringify(resumeFields));
    data[index].data[0]["description"] = value;
    if (height != undefined) {
      data[index]["height"] = height;
    }
    setResumeFields(data);
  };

  const handleSliderChange = (type) => {
    let data = JSON.parse(JSON.stringify(resumeFields));
    data["editorSettings"]["skills"]["sliderType"] = type;
    setResumeFields(data);
    resumePageUpdate(data, true);
  };
  const handleProfileImageChange = (type) => {
    let data = JSON.parse(JSON.stringify(resumeFields));
    data["editorSettings"]["profile"]["photoStyle"] = type;
    setResumeFields(data);
    resumePageUpdate(data, true);
  };

  const handleBorderChange = (type) => {
    let data = JSON.parse(JSON.stringify(resumeFields));
    data["editorSettings"]["additionalSkills"]["border"] = type;
    setResumeFields(data);
    resumePageUpdate(data, true);
  };

  const contentAdder = (value, index, section) => {
    let data = { ...resumeFields, initialLoad: false };
    if (
      data[section].data[index]["description"] == "<ul><li><br></li></ul>" ||
      data[section].data[index]["description"] == "<p><br></p>"
    ) {
      data[section].data[index]["description"] = data[section].data[index][
        "description"
      ]
        ? value
        : value;
    } else {
      data[section].data[index]["description"] = data[section].data[index][
        "description"
      ]
        ? data[section].data[index]["description"] + value
        : value;
    }

    setResumeFields(data);
    resumePageUpdate(data, true);
  };

  const resumeHandler = (e, index, type = "basic", section) => {
    SetIsDataUpdated(true);
    setRand(1);
    let targetName =
      type == "visual" ? e.target.getAttribute("name") : e.target.name;
    let data = { ...resumeFields, initialLoad: false };
    data[section].data[index][targetName] =
      type == "visual" ? e.target.innerText : e.target.value;
    if (height != undefined) {
      data["height"] = height;
    }

    if (targetName == "jobTitle") {
      let local_jobtitle = JSON.parse(localStorage.getItem("user_settings"));
      if (local_jobtitle) {
        local_jobtitle.editor = {
          job_title: data[section].data[index][targetName],
        };
      } else {
        local_jobtitle = {};
        local_jobtitle.editor = {
          job_title: data[section].data[index][targetName],
        };
      }

      localStorage.setItem("user_settings", JSON.stringify(local_jobtitle));
      dispatch(isJobPresent(data[section].data[index][targetName]));
    }
    setResumeFields(data);
  };

  const resumeTitleHandler = (e, index, type = "basic", section) => {
    setRand(1);
    let targetName =
      type == "visual" ? e.target.getAttribute("name") : e.target.name;
    let data = { ...resumeFields, initialLoad: false };
    data[section][targetName] =
      type == "visual" ? e.target.innerText.trim() : e.target.value;
    setResumeFields(data);
    // resumeUpdate(true);
  };
  const resumeTitleRemove = (e, index, type = "basic", section) => {
    setRand(1);
    let targetName =
      type == "visual" ? e.target.getAttribute("name") : e.target.name;
    let data = { ...resumeFields, initialLoad: false };
    data[section][targetName] = type == "visual" ? "" : "";
    setResumeFields(data);
    resumeUpdate(true);
  };

  const handleEditorChange = (value, index, section, source, type) => {
    if (isJon) {
      return;
    } else if (source == "api" && !isVisualEditor) {
      return;
    } else {
      let data = { ...resumeFields, initialLoad: false };
      data[section].data[index]["description"] = value;
      if (height != undefined) {
        data["height"] = height;
      }
      if (path && path.includes("create")) {
        if (source && source === "user") {
          setResumeFields(data);
          setRand(1);
        } else {
        }
      } else {
        SetIsDataUpdated(true);
        setResumeFields(data);
        setRand(1);
      }
    }
  };

  const dateHandler = (name, value, index, section) => {
    let targetName = name;
    let data = { ...resumeFields, initialLoad: false };
    data[section].data[index]["dateRange"][targetName] = value;
    if (height != undefined) {
      data["height"] = height;
    }
    setResumeFields(data);
    resumePageUpdate(data, true);
  };
  const handleCustomDelete = (value, section) => {
    //Hanndled for profile only. If other section need to pass index from profile also
    let data = { ...resumeFields, initialLoad: false };
    delete data[section].data[0][value];
    setResumeFields(data);
    resumeUpdate(true);
  };
  const languageHandler = (name, index, value, section, type = "basic") => {
    let targetName = name;
    let data = { ...resumeFields, initialLoad: false };
    data[section].data[index][targetName] = type == "visual" ? "" : value;
    setResumeFields(data);
    // resumePageUpdate(data, true);
    setRand(1);
  };
  const resetImage = (section) => {
    let data = { ...resumeFields, initialLoad: false };
    data[section].data[0]["photo"] = "";
    setResumeFields(data);
    resumeUpdate(true);
  };
  const addResumeField = (ref, value, section) => {
    // setSectionFocusData(sectionId);
    let data = { ...resumeFields, initialLoad: false };
    switch (section) {
      case "profile":
        setResumeFields((prevState) => {
          if (Object.keys(prevState).length > 0) {
            let data = { ...prevState, initialLoad: false };
            let fieldLength = Object.keys(data[section].data[0]).filter((key) =>
              key.includes("customField")
            ).length;
            let customField = `customField_${fieldLength + 1}`;
            if (value != "custom") {
              data[section].data[0] = { ...data[section].data[0], [value]: "" };
              data[section].data[0].showFields = {
                ...data[section].data[0].showFields,
                [value]: true,
              };
            } else {
              data[section].data[0] = {
                ...data[section].data[0],
                [customField]: "",
              };
              data[section].data[0].showFields = {
                ...data[section].data[0].showFields,
                [customField]: true,
              };
            }
            resumePageUpdate(data, true);
            return data;
          }
        });
        break;
      case "summary":
        // setResumeFields((prevState) => {
        //   if (Object.keys(prevState).length > 0) {
        //     return {
        //       ...prevState,
        //       data: [...prevState.data, { ...summary.data[0] }],
        //       initialLoad: false,
        //     };
        //   } else {
        //     return { ...summary };
        //   }
        // });
        break;
      case "experience":
        data[section].data = [...data[section].data, { ...experience.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "education":
        data[section].data = [...data[section].data, { ...education.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "skills":
        data[section].data = [...data[section].data, { ...skills.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "languages":
        data[section].data = [...data[section].data, { ...languages.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "achievements":
        data[section].data = [
          ...data[section].data,
          { ...achievements.data[0] },
        ];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "interests":
        data[section].data = [...data[section].data, { ...interests.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "strengths":
        data[section].data = [...data[section].data, { ...strengths.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "customDate":
        data[section].data = [...data[section].data, { ...customDate.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "customText":
        data[section].data = [...data[section].data, { ...customText.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "projects":
        data[section].data = [...data[section].data, { ...projects.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "volunteering":
        data[section].data = [
          ...data[section].data,
          { ...volunteering.data[0] },
        ];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "onlinePresence":
        data[section].data = [
          ...data[section].data,
          { ...onlinePresence.data[0] },
        ];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "certifications":
        data[section].data = [
          ...data[section].data,
          { ...certifications.data[0] },
        ];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "references":
        data[section].data = [...data[section].data, { ...references.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "publications":
        data[section].data = [
          ...data[section].data,
          { ...publications.data[0] },
        ];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "books":
        data[section].data = [...data[section].data, { ...books.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "additionalExperience":
        data[section].data = [
          ...data[section].data,
          { ...additionalExperience.data[0] },
        ];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "additionalSkills":
        data[section].data = [
          ...data[section].data,
          { ...additionalSkills.data[0] },
        ];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "courses":
        data[section].data = [...data[section].data, { ...courses.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "industryExpertise":
        data[section].data = [
          ...data[section].data,
          { ...industryExpertise.data[0] },
        ];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      case "techStack":
        data[section].data = [...data[section].data, { ...techStack.data[0] }];
        setRandFocus(1);
        setResumeFields(data);
        resumePageUpdate(data, true);
        break;
      default:
        break;
    }
  };
  const changeIconSettings = () => {
    let data = { ...resumeFields };
    data.editorSettings.showIcon = !data.editorSettings.showIcon;
    setResumeFields(data);
    resumePageUpdate(data, true);
  };
  const showHideElements = (key, index, section) => {
    let data = { ...resumeFields };

    data[section].data[index].showFields[key] =
      data &&
      data[section].data &&
      data[section].data[index] &&
      data[section].data[index].showFields &&
      data[section].data[index].showFields[key] == true
        ? false
        : true;
    setResumeFields(data);
    resumePageUpdate(data, true);
  };
  const showHideBackground = () => {
    let data = { ...resumeFields };
    data["customization"].background.bgShow =
      !data["customization"].background.bgShow;
    setResumeFields(data);
    resumePageUpdate(data, true);
  };
  const sectionMoveUp = (layout, sectionId) => {
    let data = { ...resumeFields };

    let result = data.sectionPosition;
    let index = result[layout].indexOf(sectionId);
    if (index == -1) {
      return;
    }
    if (index == 0) {
      return;
    }
    let nextIndex = parseInt(index) - parseInt(1);
    let temp = result[layout][nextIndex];
    result[layout][nextIndex] = result[layout][index];
    result[layout][index] = temp;
    data.sectionPosition = result;
    setResumeFields(data);
    resumePageUpdate(data, true);

    // setComponentArray(result);
    // setCheckChangePosition(Math.random());
  };

  const sectionMoveDown = (layout, sectionId) => {
    let data = { ...resumeFields };

    let result = data.sectionPosition;
    let index = result[layout].indexOf(sectionId);
    if (index == -1) {
      return;
    }
    if (index == result[layout].length - 1) {
      return;
    }
    let nextIndex = parseInt(index) + parseInt(1);
    let temp = result[layout][nextIndex];
    result[layout][nextIndex] = result[layout][index];
    result[layout][index] = temp;
    data.sectionPosition = result;
    setResumeFields(data);

    resumePageUpdate(data, true);
  };

  const resumeCustomHandler = (e, index, type = "basic", mainIndex) => {
    let targetName =
      type == "visual" ? e.target.getAttribute("name") : e.target.name;
    let data = JSON.parse(JSON.stringify(resumeFields));
    data[mainIndex].data[index][targetName] =
      type == "visual" ? e.target.innerText : e.target.value;
    if (height != undefined) {
      data["height"] = height;
    }
    setResumeFields(data);
  };

  const sizeHandler = (e) => {
    setRand(1);
    let data = { ...resumeFields, initialLoad: false };
    data.customization["fontSize"] = e.target.value;
    setResumeFields(data);
    resumePageUpdate(data, true, "visual");
  };

  const skillsLevelHandler = (value, index) => {
    console.log(value, "value");
    setRand(1);
    let data = { ...resumeFields, initialLoad: false };
    data.skills.data[index]["level"] = value;
    setResumeFields(data);
    resumePageUpdate(data, true, "visual");
  };

  const bgColorHandler = (index) => {
    setRand(1);
    let data = { ...resumeFields, initialLoad: false };
    data.customization.bgColor["bgColor"] = index;
    setResumeFields(data);
    // resumePageUpdate(data, true, "visual");
  };

  const handlePageMargin = (e) => {
    let data = { ...resumeFields, initialLoad: false };
    data.customization["PageMargin"] = e.target.value;
    setResumeFields(data);
    resumePageUpdate(data, true, "visual");
  };
  const handleSectionMargin = (e) => {
    let data = { ...resumeFields, initialLoad: false };
    data.customization["SectionMargin"] = e.target.value;
    setResumeFields(data);
    resumePageUpdate(data, true, "visual");
  };
  const fontHandler = (e, name, type = "basic") => {
    let data = { ...resumeFields, initialLoad: false };
    data.customization[name] = e.target.value;
    setResumeFields(data);
    resumePageUpdate(data, true, "visual");
  };

  const multiColorHandler = (primary, secondary, sectiontitleBgColor) => {
    let data = { ...resumeFields, initialLoad: false };
    data.customization.primaryColor = primary;
    data.customization.secondaryColor = secondary;
    data.customization.sectiontitleBgColor = sectiontitleBgColor;

    const checkLockedFeature =
      data["lockedFeatures"] === undefined ? false : true;
    if (!checkLockedFeature) {
      data["lockedFeatures"] = [];
    }
    const objWithIdIndex =
      data &&
      data["lockedFeatures"] &&
      data["lockedFeatures"].findIndex((obj) => obj === "design");
    if (objWithIdIndex === -1) {
      data["lockedFeatures"].push("design");
    }

    setResumeFields(data);
    resumePageUpdate(data, true, "visual");
  };

  const colorHandler = (e, name, update) => {
    setRand(1);
    let data = { ...resumeFields, initialLoad: false };
    data.customization[name] = e.target.value;
    const checkLockedFeature =
      data["lockedFeatures"] === undefined ? false : true;
    if (!checkLockedFeature) {
      data["lockedFeatures"] = [];
    }
    const objWithIdIndex =
      data &&
      data["lockedFeatures"] &&
      data["lockedFeatures"].findIndex((obj) => obj === "design");
    if (objWithIdIndex === -1) {
      data["lockedFeatures"].push("design");
    }
    setResumeFields(data);
  };

  const backgroundUpdate = (img) => {
    let data = { ...resumeFields, initialLoad: false };
    if (!data.customization.background.bgShow) {
      data.customization.background.bgShow =
        !data.customization.background.bgShow;
    }
    data.customization.background.bgImage = img;

    const checkLockedFeature =
      data["lockedFeatures"] === undefined ? false : true;
    if (!checkLockedFeature) {
      data["lockedFeatures"] = [];
    }
    const objWithIdIndex =
      data &&
      data["lockedFeatures"] &&
      data["lockedFeatures"].findIndex((obj) => obj === "design");
    if (objWithIdIndex === -1) {
      data["lockedFeatures"].push("design");
    }
    setResumeFields(data);
    resumePageUpdate(data, true, "visual");
  };

  const resumeUpdate = (isUpdate, undo) => {
    resumePageUpdate(resumeFields, isUpdate, undo);
  };

  const layoutHandler = () => {
    let globalLayout = [];
    let dataArray = { ...resumeData, initialLoad: false };
    let resdata = resumeData;

    let sectionPosition = dataArray.sectionPosition;

    const standardHeight = resume && resume.isLetter ? 1075 : 1205;

    const layoutData1 =
      layoutData && layoutData[0] && layoutData[0].length > 0
        ? layoutData
        : resdata.layout;
    let calculateTitleHeight = true;
    if (document.querySelector(`#resume-editor-0`)) {
      var templateID = document.getElementById("resume-editor-0");
      if (templateID.classList.contains("temp-15")) {
        calculateTitleHeight = false;
      }
    }
    ["lsbar", "rsbar"].map((position, index) => {
      const arrayIndex = position == "lsbar" ? 0 : 1;

      let layoutArray = [];
      let page = 0;
      let pageHeight = 0;

      let extraHeight = document.querySelector(`#top-extra`)
        ? outerFullHeight("#top-extra")
        : 0;

      sectionPosition &&
        sectionPosition[position] &&
        sectionPosition[position].map((res, sectionIndex) => {
          let sectionHeight = 10;
          if (sectionIndex == 0) {
            sectionHeight += extraHeight;
          }

          layoutData1 &&
            layoutData1[arrayIndex] &&
            layoutData1[arrayIndex]
              .filter((x) => x.section == res)
              .map((layoutData, layoutIndex) => {
                sectionHeight = document.querySelector(
                  `#${res}-${layoutData.page}-section`
                )
                  ? sectionHeight +
                    outerFullHeight(`#${res}-${layoutData.page}-section`)
                  : sectionHeight;
              });

          if (pageHeight + sectionHeight > standardHeight) {
            const sectionFullHeight = [
              "skills",
              "languages",
              "interests",
              "books",
              "references",
              "onlinePresence",
              "industryExpertise",
              "additionalSkills",
            ];
            if (!sectionFullHeight.includes(res)) {
              let titleHeight = 0;
              if (calculateTitleHeight) {
                titleHeight = document.querySelector(`#${res}-title`)
                  ? outerFullHeight(`#${res}-title`)
                  : 0;
              }

              resumeData[res] &&
                resumeData[res].data &&
                resumeData[res].data.map((data, index) => {
                  let sectionIndexHeight = document.querySelector(
                    `#${res}-${index}`
                  )
                    ? outerFullHeight(`#${res}-${index}`)
                    : 0;
                  if (pageHeight + sectionIndexHeight > standardHeight) {
                    pageHeight = 0;
                    page = page + 1;
                    layoutArray.push({
                      section: res,
                      page: page,
                      height: 0,
                      itemIndexes: [],
                    });
                    pageHeight = pageHeight + titleHeight + sectionIndexHeight;
                    layoutArray[layoutArray.length - 1].itemIndexes.push(index);
                    layoutArray[layoutArray.length - 1].height =
                      sectionIndexHeight + titleHeight;
                  } else {
                    if (index == 0) {
                      layoutArray.push({
                        section: res,
                        page: page,
                        height: 0,
                        itemIndexes: [],
                      });
                      pageHeight =
                        pageHeight + titleHeight + sectionIndexHeight;
                      layoutArray[layoutArray.length - 1].itemIndexes.push(
                        index
                      );
                      layoutArray[layoutArray.length - 1].height =
                        sectionIndexHeight + titleHeight;
                    } else {
                      pageHeight = pageHeight + sectionIndexHeight;
                      layoutArray[layoutArray.length - 1].itemIndexes.push(
                        index
                      );
                      layoutArray[layoutArray.length - 1].height =
                        layoutArray[layoutArray.length - 1].height +
                        sectionIndexHeight;
                    }
                  }
                });
            } else {
              let titleHeight = 0;
              if (calculateTitleHeight) {
                titleHeight = document.querySelector(`#${res}-title`)
                  ? outerFullHeight(`#${res}-title`)
                  : 0;
              }
              var minmax = document.getElementsByClassName(
                `${res}-item-wrapper`
              );
              let common_array = [];
              let gridColumnCount;
              let gridComputedStyle;
              let g1ridRow;
              let gridArray;

              if (!minmax || minmax === null || minmax.length < 1) {
                layoutArray.push({
                  section: res,
                  page: page,
                  height: sectionHeight,
                  itemIndexes: [],
                });
                pageHeight = pageHeight + sectionHeight;
                resumeData[res] &&
                  resumeData[res].data &&
                  resumeData[res].data.map((data, index) => {
                    layoutArray[layoutArray.length - 1].itemIndexes.push(index);
                  });
                return;
              } else {
                for (let items_page of minmax) {
                  if (!items_page || items_page === null) {
                    continue;
                  }
                  gridComputedStyle = window.getComputedStyle(items_page);
                  g1ridRow = gridComputedStyle
                    .getPropertyValue("grid-template-rows")
                    .replaceAll("px", "")
                    .split(" ");
                  gridColumnCount = gridComputedStyle
                    .getPropertyValue("grid-template-columns")
                    .split(" ").length;
                  common_array.push(...g1ridRow);
                }
                let g1ridRowCount = common_array.length;

                if (resdata && resdata[res] && resdata[res].data) {
                  let totalitems = resdata[res].data.length;
                  let newRowCount = Math.ceil(totalitems / gridColumnCount);
                  if (newRowCount > common_array.length) {
                    common_array.push(common_array[g1ridRowCount - 1]);
                  }
                }
                g1ridRowCount = common_array.length;

                gridArray = twoDarrMaker(g1ridRowCount, gridColumnCount);

                common_array.map((sectionIndexHeight, row) => {
                  sectionIndexHeight = Math.ceil(sectionIndexHeight);

                  if (pageHeight + sectionIndexHeight > standardHeight) {
                    let titleHeight = document.querySelector(`#${res}-title`)
                      ? outerFullHeight(`#${res}-title`)
                      : 0;

                    page = page + 1;
                    layoutArray.push({
                      section: res,
                      page: page,
                      height: 0,
                      itemIndexes: [],
                    });
                    pageHeight = titleHeight + sectionIndexHeight;

                    layoutArray[layoutArray.length - 1].itemIndexes.push(
                      ...gridArray[row]
                    );
                    layoutArray[layoutArray.length - 1].height =
                      sectionIndexHeight;
                  } else {
                    if (row == 0) {
                      layoutArray.push({
                        section: res,
                        page: page,
                        height: sectionHeight,
                        itemIndexes: [],
                      });
                      pageHeight =
                        sectionIndex == 0
                          ? extraHeight +
                            pageHeight +
                            sectionIndexHeight +
                            titleHeight
                          : pageHeight + sectionIndexHeight + titleHeight;

                      layoutArray[layoutArray.length - 1].itemIndexes.push(
                        ...gridArray[row]
                      );
                      layoutArray[layoutArray.length - 1].height =
                        sectionIndexHeight;
                    } else {
                      pageHeight = pageHeight + sectionIndexHeight;
                      layoutArray[layoutArray.length - 1].itemIndexes.push(
                        ...gridArray[row]
                      );
                      layoutArray[layoutArray.length - 1].height =
                        layoutArray[layoutArray.length - 1].height +
                        sectionIndexHeight;
                    }
                  }
                });
              }
            }
          } else {
            pageHeight = pageHeight + sectionHeight;
            layoutArray.push({
              section: res,
              page: page,
              height: sectionHeight,
              itemIndexes: [],
            });
            resumeData[res] &&
              resumeData[res].data &&
              resumeData[res].data.map((data, index) => {
                layoutArray[layoutArray.length - 1].itemIndexes.push(index);
              });
          }
          sectionHeight = 0;
        });

      globalLayout.push(layoutArray);
    });
    let data = { ...resumeFields, initialLoad: false };
    if (data && data.layout) {
      data.layout = globalLayout;
      setResumeFields(data);
    }

    dataArray.layout = globalLayout;
    // setDataChanged(true);
    // setChangedData(dataArray);
    // resumePageUpdate(dataArray);

    dispatch(changeLayout(globalLayout));
    // dispatch({
    //   type: LAYOUT_ADD,
    //   payload: globalLayout,
    // });
    // resdata.layout = globalLayout;
  };

  const resumeUpdateCancel = () => {
    setResumeFields(JSON.parse(JSON.stringify(editorData)));
  };

  const sectionClick = (e, title) => {
    setSectionFocus(true);
    setVisualEditorFocus(true);
  };

  const sectionItemClick = (e, title) => {
    setSectionFocus(false);
    setVisualEditorFocus(true);
  };

  const editPopupShow = (index, section) => {
    setShowPopup(true);
    setSectionId(section);
    setArrayIndex(index);
  };
  const deletePopupShow = (index, section) => {
    setShowDeletePopup(true);
    setSectionId(section);
    setCustomIndex(index);
  };

  const handleSectionDelete = (section, bySection) => {
    if (bySection) {
      sectionDelete(section);
    } else {
      sectionDelete(sectionId);
    }
    // sectionDelete(sectionId);
    setCustomIndex("");
  };

  const getSectionIndexBySectionId = (sectionId, sectionType) => {
    let data = { ...resumeFields, initialLoad: false };

    let componentArray = data.sectionPosition;
    if (componentArray && componentArray[sectionType]) {
      return componentArray[sectionType].findIndex((x) => x == sectionId);
    } else {
      return -1;
    }
  };

  const sectionDelete = (sectionId) => {
    let mainIndex = getSectionIndexBySectionId(sectionId, "main");
    let lsbarIndex = getSectionIndexBySectionId(sectionId, "lsbar");
    let rsbarIndex = getSectionIndexBySectionId(sectionId, "rsbar");

    if (lsbarIndex != -1) {
      deleteSectionBySectionId(lsbarIndex, "lsbar");
    }

    if (rsbarIndex != -1) {
      deleteSectionBySectionId(rsbarIndex, "rsbar");
    }

    if (mainIndex != -1) {
      deleteSectionBySectionId(mainIndex, "main");
    }
  };

  const deleteSectionBySectionId = (index, sectionType) => {
    let data = { ...resumeFields, initialLoad: false };

    // let data = { ...componentArray };
    data.sectionPosition[sectionType] = data.sectionPosition[sectionType]
      .slice(0, index)
      .concat(
        data.sectionPosition[sectionType].slice(
          index + 1,
          data.sectionPosition[sectionType].length
        )
      );

    let isPremiumPresentLsbar = false;
    let isPremiumPresentRsbar = false;

    for (var i = 0; i < paidSections.length; i++) {
      if (data.sectionPosition["lsbar"]) {
        let lsbarIndex = data.sectionPosition["lsbar"].findIndex(
          (obj) => obj === paidSections[i]
        );
        let lsbarCustomIndex = data.sectionPosition["lsbar"].findIndex((obj) =>
          obj.includes("custom")
        );

        if (lsbarIndex > -1 || lsbarCustomIndex > -1) {
          isPremiumPresentLsbar = true;
          break;
        }
      }

      if (data.sectionPosition["rsbar"]) {
        let rsbarIndex = data.sectionPosition["rsbar"].findIndex(
          (obj) => obj === paidSections[i]
        );
        let rsbarCustomIndex = data.sectionPosition["rsbar"].findIndex((obj) =>
          obj.includes("custom")
        );
        if (rsbarIndex > -1 || rsbarCustomIndex > -1) {
          isPremiumPresentRsbar = true;
          break;
        }
      }
    }

    const checkLockedFeature =
      data["lockedFeatures"] === undefined ? false : true;
    if (!checkLockedFeature) {
      data["lockedFeatures"] = [];
    }
    const objWithIdIndex =
      data &&
      data["lockedFeatures"] &&
      data["lockedFeatures"].findIndex((obj) => obj === "section");

    if (isPremiumPresentLsbar || isPremiumPresentRsbar) {
      if (objWithIdIndex === -1) {
        data["lockedFeatures"].push("section");
      }
    } else {
      if (objWithIdIndex > -1) {
        data &&
          data["lockedFeatures"] &&
          data["lockedFeatures"].splice(objWithIdIndex, 1);
      }
    }

    setResumeFields(data);
    resumePageUpdate(data, true);
    // setCheckChangePosition(Math.random());
  };

  const setSection = async (sectionId, sectionType) => {
    let data = { ...resumeFields, initialLoad: false };
    let componentArray = data.sectionPosition;
    // setSectionFocusData(sectionId);
    if (sectionId == "customDate") {
      let pushSectionType = "rsbar";
      let lsbarIndexCheck = true;
      let rsbarIndexCheck = true;

      if (lsbarIndexCheck && rsbarIndexCheck) {
        addSectionIdtoSectionPosition(pushSectionType, sectionId, sectionType);
        setRandFocus(1);
      }
    } else if (sectionId == "customText") {
      let pushSectionType = "rsbar";
      let lsbarIndexCheck = true;
      let rsbarIndexCheck = true;

      if (lsbarIndexCheck && rsbarIndexCheck) {
        addSectionIdtoSectionPosition(pushSectionType, sectionId, sectionType);
        setRandFocus(1);
      }
    } else {
      let pushSectionType = "main";
      let lsbarIndexCheck = true;
      let rsbarIndexCheck = true;
      let mainIndexCheck = true;
      if (componentArray["lsbar"]) {
        pushSectionType = "lsbar";
        let lsbarIndex = await getSectionIndexBySectionId(sectionId, "lsbar");

        if (lsbarIndex != -1) {
          lsbarIndexCheck = false;
        }
      }
      if (componentArray["rsbar"]) {
        pushSectionType = "rsbar";
        let rsbarIndex = await getSectionIndexBySectionId(sectionId, "rsbar");
        if (rsbarIndex != -1) {
          rsbarIndexCheck = false;
        }
      }
      if (componentArray["main"]) {
        pushSectionType = "main";
        let mainIndex = await getSectionIndexBySectionId(sectionId, "main");
        if (mainIndex != -1) {
          mainIndexCheck = false;
        }
      }
      if (lsbarIndexCheck && rsbarIndexCheck && mainIndexCheck) {
        addSectionIdtoSectionPosition(pushSectionType, sectionId, sectionType);
        setRandFocus(1);
      }
    }
  };

  const addSectionIdtoSectionPosition = (
    pushSectionType,
    sectionId,
    sectionType
  ) => {
    let dataArray = { ...resumeFields, initialLoad: false };

    // To get the last page
    const lsbarPage =
      dataArray.layout &&
      dataArray.layout[0] &&
      dataArray.layout[0].length > 0 &&
      dataArray.layout[0][dataArray.layout[0].length - 1].page &&
      dataArray.layout[0][dataArray.layout[0].length - 1].page
        ? dataArray.layout[0][dataArray.layout[0].length - 1].page
        : 0;

    const rsbarPage =
      dataArray.layout &&
      dataArray.layout[1] &&
      dataArray.layout[1].length > 0 &&
      dataArray.layout[1][dataArray.layout[1].length - 1].page &&
      dataArray.layout[1][dataArray.layout[1].length - 1].page
        ? dataArray.layout[1][dataArray.layout[1].length - 1].page
        : 0;

    let componentArray = dataArray.sectionPosition;
    let customStyle = dataArray.customization;
    let data = { ...componentArray };
    let type = "";
    if (sectionType) {
      type = sectionType;
    } else {
      type = pushSectionType;
    }
    if (sectionId && sectionId.includes("customDate")) {
      const findLength = caluclateCount(sectionId, data);
      if (customStyle && customStyle.resumeLayout == "double") {
        data[type].push(`${sectionId}_${findLength + 1}`);
      } else {
        data["lsbar"].push(`${sectionId}_${findLength + 1}`);
      }
      dataArray[`${sectionId}_${findLength + 1}`] = { ...customDate };
      dataArray.sectionPosition = data;
      setSectionFocusData(`${sectionId}_${findLength + 1}`);

      const checkLockedFeature =
        dataArray["lockedFeatures"] === undefined ? false : true;
      if (!checkLockedFeature) {
        dataArray["lockedFeatures"] = [];
      }

      const objWithIdIndex =
        dataArray &&
        dataArray["lockedFeatures"] &&
        dataArray["lockedFeatures"].findIndex((obj) => obj === "section");

      if (objWithIdIndex === -1) {
        dataArray["lockedFeatures"].push("section");
      }

      setResumeFields(dataArray);
      resumePageUpdate(dataArray, true);
    } else if (sectionId && sectionId.includes("customText")) {
      const findLength = caluclateCount(sectionId, data);
      if (customStyle && customStyle.resumeLayout == "double") {
        data[type].push(`${sectionId}_${findLength + 1}`);
      } else {
        data["lsbar"].push(`${sectionId}_${findLength + 1}`);
      }
      dataArray[`${sectionId}_${findLength + 1}`] = { ...customText };
      dataArray.sectionPosition = data;
      setSectionFocusData(`${sectionId}_${findLength + 1}`);

      const checkLockedFeature =
        dataArray["lockedFeatures"] === undefined ? false : true;
      if (!checkLockedFeature) {
        dataArray["lockedFeatures"] = [];
      }

      const objWithIdIndex =
        dataArray &&
        dataArray["lockedFeatures"] &&
        dataArray["lockedFeatures"].findIndex((obj) => obj === "section");
      if (objWithIdIndex === -1) {
        dataArray["lockedFeatures"].push("section");
      }
      setResumeFields(dataArray);
      resumePageUpdate(dataArray, true);
    } else {
      if (customStyle && customStyle.resumeLayout == "double") {
        data[type].push(sectionId);
        if (type == "rsbar") {
          dataArray.layout[1].push({
            section: sectionId,
            page: rsbarPage,
            height: 150,
            itemIndexes: [],
          });
        } else {
          dataArray.layout[0].push({
            section: sectionId,
            page: lsbarPage,
            height: 150,
            itemIndexes: [],
          });
        }
      } else {
        data["lsbar"].push(sectionId);
        dataArray.layout[0].push({
          section: sectionId,
          page: lsbarPage,
          height: 150,
          itemIndexes: [],
        });
      }
      setSectionFocusData(sectionId);
      switch (sectionId) {
        case "profile":
          break;
        case "summary":
          break;
        case "experience":
          dataArray["experience"] = { ...experience };
          break;
        case "education":
          dataArray["education"] = { ...education };
          break;
        case "skills":
          dataArray["skills"] = { ...skills };
          break;
        case "languages":
          dataArray["languages"] = { ...languages };
          break;
        case "achievements":
          dataArray["achievements"] = { ...achievements };
          break;
        case "interests":
          dataArray["interests"] = { ...interests };
          break;
        case "strengths":
          dataArray["strengths"] = { ...strengths };
          break;
        case "projects":
          dataArray["projects"] = { ...projects };
        case "volunteering":
          dataArray["volunteering"] = { ...volunteering };
        case "onlinePresence":
          dataArray["onlinePresence"] = { ...onlinePresence };
        case "certifications":
          dataArray["certifications"] = { ...certifications };
        case "references":
          dataArray["references"] = { ...references };
        case "publications":
          dataArray["publications"] = { ...publications };
        case "books":
          dataArray["books"] = { ...books };
        case "additionalExperience":
          dataArray["additionalExperience"] = { ...additionalExperience };
        case "additionalSkills":
          dataArray["additionalSkills"] = { ...additionalSkills };
        case "courses":
          dataArray["courses"] = { ...courses };
        case "industryExpertise":
          dataArray["industryExpertise"] = { ...industryExpertise };
        case "techStack":
          dataArray["techStack"] = { ...techStack };
          break;
        case "customization":
          break;
        case "from":
          break;
        case "to":
          break;
        case "content":
          break;
        default:
          break;
      }
      dataArray.sectionPosition = data;

      let isPremiumPresentLsbar = false;
      let isPremiumPresentRsbar = false;

      for (var i = 0; i < paidSections.length; i++) {
        if (dataArray.sectionPosition["lsbar"]) {
          let lsbarIndex = dataArray.sectionPosition["lsbar"].findIndex(
            (obj) => obj === paidSections[i]
          );
          let lsbarCustomIndex = dataArray.sectionPosition["lsbar"].findIndex(
            (obj) => obj.includes("custom")
          );

          if (lsbarIndex > -1 || lsbarCustomIndex > -1) {
            isPremiumPresentLsbar = true;
            break;
          }
        }

        if (dataArray.sectionPosition["rsbar"]) {
          let rsbarIndex = dataArray.sectionPosition["rsbar"].findIndex(
            (obj) => obj === paidSections[i]
          );
          let rsbarCustomIndex = dataArray.sectionPosition["rsbar"].findIndex(
            (obj) => obj.includes("custom")
          );
          if (rsbarIndex > -1 || rsbarCustomIndex > -1) {
            isPremiumPresentRsbar = true;
            break;
          }
        }
      }

      // paidSections && paidSections.map((res) => {

      // })

      const checkLockedFeature =
        dataArray["lockedFeatures"] === undefined ? false : true;
      if (!checkLockedFeature) {
        dataArray["lockedFeatures"] = [];
      }
      const objWithIdIndex =
        dataArray &&
        dataArray["lockedFeatures"] &&
        dataArray["lockedFeatures"].findIndex((obj) => obj === "section");

      if (isPremiumPresentLsbar || isPremiumPresentRsbar) {
        if (objWithIdIndex === -1) {
          dataArray["lockedFeatures"].push("section");
        }
      } else {
        if (objWithIdIndex > -1) {
          dataArray &&
            dataArray["lockedFeatures"] &&
            dataArray["lockedFeatures"].splice(objWithIdIndex, 1);
        }
      }

      setResumeFields(dataArray);
      resumePageUpdate(dataArray, true);
      //   sectionItemAdd(sectionId);
      //   setComponentArray(data);
      //   setCheckChangePosition(Math.random());
    }
  };

  const caluclateCount = (sectionID, sectionPosition) => {
    let count = 0;
    const dataLsbar = sectionPosition["lsbar"].filter((x) =>
      x.includes(sectionID)
    ).length;
    const dataRsbar = sectionPosition["rsbar"].filter((x) =>
      x.includes(sectionID)
    ).length;
    count = dataLsbar + dataRsbar;
    return count;
  };

  const checkSectionPresentOrNot = (sectionId) => {
    let mainIndex = getSectionIndexBySectionId(sectionId, "main");
    let lsbarIndex = getSectionIndexBySectionId(sectionId, "lsbar");
    let rsbarIndex = getSectionIndexBySectionId(sectionId, "rsbar");

    if (mainIndex == -1 && lsbarIndex == -1 && rsbarIndex == -1) {
      return true;
    } else {
      return false;
    }
  };

  const sectionItemMoveUp = (e, index, section) => {
    e.stopPropagation();
    let data = { ...resumeFields, initialLoad: false };
    let result = data[section];
    if (index == 0) {
      return;
    }
    let nextIndex = parseInt(index) - parseInt(1);
    let temp = { ...result.data[nextIndex] };
    result.data[nextIndex] = { ...result.data[index] };
    result.data[index] = { ...temp };
    data[section] = result;
    setResumeFields(data);
    resumePageUpdate(data, true);
    // setResumeFields(result);
  };

  const sectionItemMoveDown = (e, index, section) => {
    e.stopPropagation();
    let data = { ...resumeFields, initialLoad: false };
    let result = data[section];
    if (index == result.data.length - 1) {
      return;
    }
    let nextIndex = parseInt(index) + parseInt(1);
    let temp = { ...result.data[nextIndex] };
    result.data[nextIndex] = { ...result.data[index] };
    result.data[index] = { ...temp };
    data[section] = result;
    setResumeFields(data);
    resumePageUpdate(data, true);
  };

  const handleItemDelete = (index, section) => {
    let data = { ...resumeFields, initialLoad: false };
    let result = data[section];
    // let result = { ...resumeFields, initialLoad: false };
    if (result.data.length == 1) {
      handleSectionDelete(section, true);
    } else {
      result.data = result.data
        .slice(0, index)
        .concat(result.data.slice(index + 1, result.data.length));
      data[section] = result;
      setResumeFields(data);
      resumePageUpdate(data, true);
    }
  };

  const removeProfeatures = () => {
    let data = { ...resumeFields, initialLoad: false };
    data &&
      data.lockedFeatures &&
      data.lockedFeatures.length > 0 &&
      data.lockedFeatures.map((res) => {
        if (res == "template" || res == "design") {
          let templateData = templateList;
          let defaultTemplate =
            templateData &&
            templateData.data &&
            templateData.data.filter(
              (x) =>
                x.template_code == process.env.REACT_APP_DEFAULT_TEMPLATE_CODE
            );

          let cont =
            defaultTemplate && defaultTemplate.length > 0
              ? defaultTemplate[0]
              : templateData && templateData.data && templateData.data[0];
          data["sectionPosition"] =
            cont && cont.settings && cont.settings.sectionPosition;
          data["editorSettings"] =
            cont && cont.settings && cont.settings.editorSettings;

          //update Layout
          let layoutArray = data["layout"];
          let movedArray = cont && cont.settings && cont.settings.layout;

          ["lsbar", "rsbar"].map((position, index) => {
            layoutArray[index].map((data) => {
              let tempData = data;
              let indexNumLeft = movedArray[0].findIndex(
                (x) => x.section == data.section
              );
              let indexNumRight = movedArray[1].findIndex(
                (x) => x.section == data.section
              );

              if (indexNumLeft == -1 && indexNumRight == -1) {
                if (cont.settings.customization.resumeLayout == "single") {
                  movedArray[0].push(tempData);
                } else {
                  movedArray[1].push(tempData);
                }
              } else {
                let itemIndex = data.itemIndexes;
                if (indexNumLeft != -1) {
                  let tempObj = movedArray[0][indexNumLeft];
                  let arr = tempObj.itemIndexes;
                  itemIndex &&
                    itemIndex.map((data) => {
                      const index = tempObj.itemIndexes.findIndex(
                        (e) => e === data
                      );
                      if (index === -1) {
                        arr.push(data);
                      } else {
                        arr[index] = data;
                      }
                    });

                  tempObj.itemIndexes = arr;
                  movedArray[0].splice(indexNumLeft, 1, tempObj);
                } else {
                  let tempObj = movedArray[1][indexNumRight];
                  let arr = tempObj.itemIndexes;
                  itemIndex &&
                    itemIndex.forEach((data) => {
                      const index = tempObj.itemIndexes.findIndex(
                        (e) => e === data
                      );
                      if (index === -1) {
                        arr.push(data);
                      } else {
                        arr[index] = data;
                      }
                    });

                  tempObj.itemIndexes = arr;
                  movedArray[1].splice(indexNumRight, 1, tempObj);
                }
              }
            });
          });

          data["layout"] = movedArray;
          dispatch(changeLayout(movedArray));
          const objWithIdIndex =
            data &&
            data["lockedFeatures"] &&
            data["lockedFeatures"].findIndex((obj) => obj === "template");
          if (
            data &&
            data["lockedFeatures"] &&
            data["lockedFeatures"].length > 0
          ) {
            if (objWithIdIndex > -1) {
              data &&
                data["lockedFeatures"] &&
                data["lockedFeatures"].splice(objWithIdIndex, 1);
            }
          }
          const objWithIdIndexDesign =
            data &&
            data["lockedFeatures"] &&
            data["lockedFeatures"].findIndex((obj) => obj === "design");
          if (
            data &&
            data["lockedFeatures"] &&
            data["lockedFeatures"].length > 0
          ) {
            if (objWithIdIndexDesign > -1) {
              data &&
                data["lockedFeatures"] &&
                data["lockedFeatures"].splice(objWithIdIndexDesign, 1);
            }
          }
          data.customization = cont.settings.customization;
          setResumeFields(data);
          dispatch({
            type: EDITOR_DATA_ADD,
            payload: data,
          });
          const body = {
            title:
              resume && resume.resume && resume.resume.title
                ? resume.resume.title
                : "",
            body: "Body123",
            content: JSON.stringify(data),
            completed: false,
            isLetter:
              resume && resume.resume && resume.resume.isLetter
                ? resume.resume.isLetter
                : 0,
            type: "resume",
            template_id: cont.template_code,
          };
          if (path && path.includes("create")) {
            data.template_id = cont.template_code;
            dispatch(sampleResumeById(resume.id, data, "isAuth"));
          }
          dispatch(templateGetParticularActions(cont.template_code));
          dispatch(
            resumeEditActions(
              resume.id,
              body
              //   res.settings.customization,
              //   cont && cont.settings && cont.settings.sectionPosition,
              //   data["editorSettings"]
            )
          );
        } else if (res === "section") {
          // var a = data.sectionPosition['lsbar']
          // var b = data.sectionPosition['rsbar']

          const filteredA = data.sectionPosition["lsbar"].filter((e) =>
            e.includes("custom")
          );
          const filteredB = data.sectionPosition["rsbar"].filter((e) =>
            e.includes("custom")
          );

          if (filteredA && filteredA.length > 0) {
            filteredA.forEach((f) =>
              data.sectionPosition["lsbar"].splice(
                data.sectionPosition["lsbar"].findIndex((e) => e === f),
                1
              )
            );
          }
          if (filteredB && filteredB.length > 0) {
            filteredB.forEach((f) =>
              data.sectionPosition["rsbar"].splice(
                data.sectionPosition["rsbar"].findIndex((e) => e === f),
                1
              )
            );
          }

          for (var i = 0; i < paidSections.length; i++) {
            let lsbarIndex1 = getSectionIndexBySectionId(
              paidSections[i],
              "lsbar"
            );
            let rsbarIndex1 = getSectionIndexBySectionId(
              paidSections[i],
              "rsbar"
            );

            if (lsbarIndex1 !== -1) {
              data.sectionPosition["lsbar"] = data.sectionPosition["lsbar"]
                .slice(0, lsbarIndex1)
                .concat(
                  data.sectionPosition["lsbar"].slice(
                    lsbarIndex1 + 1,
                    data.sectionPosition["lsbar"].length
                  )
                );
            }

            if (rsbarIndex1 !== -1) {
              data.sectionPosition["rsbar"] = data.sectionPosition["rsbar"]
                .slice(0, rsbarIndex1)
                .concat(
                  data.sectionPosition["rsbar"].slice(
                    rsbarIndex1 + 1,
                    data.sectionPosition["rsbar"].length
                  )
                );
            }
          }
          const objWithIdIndex =
            data &&
            data["lockedFeatures"] &&
            data["lockedFeatures"].findIndex((obj) => obj === "section");
          if (
            data &&
            data["lockedFeatures"] &&
            data["lockedFeatures"].length > 0
          ) {
            if (objWithIdIndex > -1) {
              data &&
                data["lockedFeatures"] &&
                data["lockedFeatures"].splice(objWithIdIndex, 1);
            }
          }
          setResumeFields(data);
          resumePageUpdate(data, true);
        }
      });
  };
  const handleAchievementSvg = (sectionIndex, svgIndex) => {
    let data = { ...resumeFields };
    data.achievements.data[sectionIndex]["svgImage"] = svgIndex;
    data.achievements.data[sectionIndex].showFields = {
      ...data.achievements.data[sectionIndex].showFields,
      ["isSvg"]: true,
    };
    setResumeFields(data);
    resumePageUpdate(data, true);
  };
  const handleItemIcon = (sectionId, index, icon) => {
    let data = { ...resumeFields };
    data[sectionId].data[index]["icon"] = icon;
    setResumeFields(data);
    resumePageUpdate(data, true);
  };
  const skillsLevelHandlerRcSlider = (value, index) => {
    console.log("triggered");
    setRand(1);
    let data = { ...resumeFields, initialLoad: false };
    data.skills.data[index]["level"] = value;
    setResumeFields(data);
    resumePageUpdate(data, true, "visual");
  };
  const handleLanguageSliderChange = (type) => {
    let data = JSON.parse(JSON.stringify(resumeFields));
    data["editorSettings"]["languages"]["indicatorType"] = type;
    setResumeFields(data);
    resumePageUpdate(data, true);
  };
  return {
    resumeFields,
    setResumeFields,
    handleEditorChange,
    handleCustomEditorChange,
    resumeHandler,
    resumeTitleHandler,
    resumeTitleRemove,
    addResumeField,
    resumeCustomHandler,
    resumeUpdate,
    resumeNavigateHistory,
    showHideElements,
    sectionMoveUp,
    sectionMoveDown,
    resumeUpdateCancel,
    sectionRef,
    childRef,
    sectionFocus,
    innerSectionFocus,
    sectionClick,
    sectionFocusOutsideClick,
    sectionItemClick,
    editPopupShow,
    deletePopupShow,
    saveIndex,
    setSaveIndex,
    languageHandler,
    dateHandler,
    fontHandler,
    multiColorHandler,
    colorHandler,
    backgroundUpdate,
    sizeHandler,
    contentAdder,
    layoutHandler,
    resumeData,
    layoutData,
    handleSectionDelete,
    setSection,
    checkSectionPresentOrNot,
    sectionItemMoveUp,
    sectionItemMoveDown,
    handleItemDelete,
    showHideBackground,
    setRandLayout,
    visualEditorFocus,
    setVisualEditorFocus,
    resetImage,
    handleCustomDelete,
    removeProfeatures,
    handleSliderChange,
    handlePageMargin,
    handleSectionMargin,
    skillsLevelHandler,
    bgColorHandler,
    handleBorderChange,
    handleProfileImageChange,
    updateHistoryData,
    resumeUpdateToServer,
    isDataUpdated,
    changeIconSettings,
    handleAchievementSvg,
    handleItemIcon,
    skillsLevelHandlerRcSlider,
    handleLanguageSliderChange,
  };
};

export default ResumeUseForm;
